module.exports = __webpack_public_path__ + "static/media/banner@768.06491c16.png";